import { Container, Grid, Box, Link } from '@mui/material';
import React from 'react';
import HomeScss from './Home.module.scss';
import Improve from '../../Component/Improve/Improve';
import OurCover from '../../Component/OurCover/OurCover';
import PricingComp from '../../Component/PricingComp/PricingComp';
import Testimonials from '../../Component/Testimonials/Testimonials';
import BlogPost from '../../Component/BlogPost/BlogPost';
import { PostData } from '../../Data/postData';
import Office from '../../Common/Image/office1.jpg';
import { StunCompData } from '../../Data/stunCompData';
import StunComp from '../../Component/StunComp/StunComp.js';

function Home() {
    return (
        <div>
            <OurCover ourHead='We provide the solutions to grow your business' title='We help startups and digital agencies launch projects on time,with no pain' />
            {/* homeServices */}
            <section id={HomeScss.homeService}>
                <Container maxWidth='lg'>
                    <Box className={HomeScss.homeServiceHead}>
                        <span>amazing services</span>
                        <h2>We're creative agency. <br /> ask as about distinctive branding</h2>
                    </Box>
                    <Grid container className={HomeScss.homeServiceBody} sx={{ width: 'auto', mx: '-15px' }}>

                        {
                            StunCompData.map(stundata =>
                                <Grid item xs={12} sm={6} md={3} sx={{ px: '15px' }} key={stundata.id}>
                                    <StunComp img={stundata.img} head={stundata.head} content={stundata.content} />
                                </Grid>
                            )
                        }

                    </Grid>
                    <Box className={HomeScss.homeServiceLink}>
                        <Link href='#'>let's talk</Link>
                    </Box>
                </Container>

            </section>
            {/* homePlan */}
            <section id={HomeScss.homePlan}>
                <Grid container className={HomeScss.homePlanCover}>
                    <Grid item xs={12} sm={5} md={5}>
                        <Box className={HomeScss.homePlanCoverLeft}>
                            <img src={Office} alt='Office'></img>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={7} md={7}>
                        <Box className={HomeScss.homePlanCoverRight}>
                            <span>our company</span>
                            <h3>Creator of quality designs and thinker of fresh ideas</h3>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. </p>
                            <Box className={HomeScss.link}>
                                <Link href='#'>read more</Link>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Grid container className={HomeScss.homePlanCover2}>
                    <Grid item xs={12} sm={7} md={7}>
                        <Box className={HomeScss.homePlanCoverLeft}>
                            <span>our company</span>
                            <h3>Creator of quality designs and thinker of fresh ideas</h3>
                            <Box className={HomeScss.homePlanCoverDifference} >
                                <Box className={HomeScss.homePlanCoverDifferenceLeft} >
                                    <Box>
                                        87
                                        <span>+</span>
                                    </Box>
                                    <h6>Business increase</h6>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </Box>
                                <Box className={HomeScss.homePlanCoverDifferenceRight} sx={{ px: '10px' }}>
                                    <Box>
                                        267
                                    </Box>
                                    <h6>new accounts</h6>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={5} md={5}>
                        <Box className={HomeScss.homePlanCoverRight}>
                            <img src={Office} alt='Office'></img>
                        </Box>
                    </Grid>
                </Grid>
            </section>
            <PricingComp />
            <Testimonials />
            {/* homeNews */}
            <section id={HomeScss.homeNews}>
                <Container maxWidth='lg'>
                    <Box className={HomeScss.homeNewsHead}>
                        <span>lastest news</span>
                        <h4>Thoughts and experiments</h4>
                    </Box>
                    <Grid container className={HomeScss.homeNewsHeadBody} sx={{ width: 'auto', mx: '-15px' }}>
                        {
                            PostData.map(post =>
                                post.id < 4 ?
                                    <Grid item xs={12} sm={6} md={4} sx={{ px: '15px' }} key={post.id}>
                                        <BlogPost subject={post.subject} date={post.date} title={post.title} content={post.content} />
                                    </Grid>
                                    : ''
                            )
                        }
                    </Grid>
                    <Box className={HomeScss.homeNewsLink}>
                        <Link href='#'>
                            read more
                        </Link>
                    </Box>
                </Container>
            </section>
            <Improve head='Ready to Improve Your Experience' content='With Busin Technology?' />
        </div >
    )
}

export default Home;
